export default __webpack_public_path__ + "img/dropbox.png";